// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bbcdb1a8","952":"7762ddf2"}[chunkId] + ".chunk.js";
};